// extracted by mini-css-extract-plugin
module.exports = {"personTbl":"style_personTbl__RE9yD"};